import React, { useEffect } from 'react';
import { HeaderTout, VideoBlock, ScrollWrapper, ToutWrapper } from './styles';
import { gsap } from 'gsap';
import useWindowSize from '@components/shared/window-size.jsx';
import BackgroundVideo from '@repo/ui/src/components/BackgroundVideo';
import { MediaType } from '@repo/ui/src/types/image';

interface ScrollProps {
  headingLight?: string;
  heading?: string;
  align?: any;
  description?: string;
  video: MediaType;
}

const AccessoryScroll = ({ headingLight, heading, align, description, video }: ScrollProps) => {
  const [width] = useWindowSize();
  const vidWidth = width > 1920 ? 1920 : width;

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.start-trig',
        pin: '.accessory-video',
        pinSpacing: false,
        start: 'top top',
        // markers: true,
        end: '+=50%',
        toggleActions: 'play complete pause reverse',
      },
    });

    //.3 opacity for text scroll in
    tl.fromTo('.accessory-video', { opacity: 1 }, { opacity: 0.3, duration: 0.5 });
    const secondTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.sec-trig',
        start: 'center top',
        toggleActions: 'play complete pause reverse',
        // markers: true,
      },
    });
    // fade all the way to black when text halfway
    secondTl.to('.accessory-video', { opacity: 0, duration: 0.5 });
    secondTl.fromTo('.accCard', { opacity: 0 }, { opacity: 1, duration: 0.5 });
  }, []);
  return (
    <ScrollWrapper className="scroll-wrapper">
      <VideoBlock className="start-trig">
        <BackgroundVideo
          video={video}
          width={vidWidth}
          fillContainer
          className={`accessory-video`}
          playButton
        />
      </VideoBlock>
      <ToutWrapper>
        <HeaderTout
          headingLight={headingLight}
          heading={heading}
          align={align}
          headingStyleVariant="h1"
          divider
          dark
          description={description}
          className="sec-trig"
        />
      </ToutWrapper>
    </ScrollWrapper>
  );
};

export default AccessoryScroll;
